<template>
  <v-navigation-drawer app clipped right stateless :value="true">
    <v-container>
      <div class="font-weight-medium text-center">{{ version.toString().padEnd(3, '.0') }}</div>
      <div class="font-weight-light text-center">Aktualna wersja{{ course.isDraft ? ' (robocza)' : '' }}</div>
      <p></p>
      <div class="font-weight-medium text-center">
        {{ lastUpdateDate || createDate | date }}
      </div>
      <div class="font-weight-light text-center">
        Ostatnia aktualizacja wersji
      </div>
      <p></p>
      <div class="font-weight-medium text-center">{{ createDate | date }}</div>
      <div class="font-weight-light text-center">Data utworzenia wersji</div>
      <v-divider class="divider" />
      <p />
      <BaseCourseEditForm v-if="course.isEditable" :course="course" />
      <v-divider v-if="course.isDraft" class="divider" />
      <SaveCourseFullVersion v-if="course.isDraft" :course="course" />
      <!--<CreateNewCourseVersion v-if="!course.isDraft && course.isEditable" :course="course" />-->
    </v-container>
  </v-navigation-drawer>
</template>

<script>
// import CreateNewCourseVersion from '@/components/manage/courses/right-panel/course-edit/CreateNewCourseVersion.vue';
import SaveCourseFullVersion from '@/components/manage/courses/right-panel/course-edit/SaveCourseFullVersion.vue';
import BaseCourseEditForm from '@/components/manage/courses/right-panel/course-edit/BaseCourseEditForm.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('courses');

export default {
  components: {
    /*CreateNewCourseVersion,*/
    SaveCourseFullVersion,
    BaseCourseEditForm
  },
  data: function() {
    return {
      newVersionDialog: false
    };
  },
  computed: mapState({
    version: state => state.activeCourseEditTree.activeElement.element.version,
    lastUpdateDate: state => state.activeCourseEditTree.activeElement.element.lastModificationTime,
    createDate: state => state.activeCourseEditTree.activeElement.element.creationTime,
    course: state => state.activeCourseEditTree.activeElement.element
  })
};
</script>

<style lang="scss" scoped>
.divider {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
